export enum CancellationsAuthorizations {
  CancellationDeathIns = 'CANCELLAZIONI.MORTE.INS',
  CancellationAire = 'CANCELLAZIONE.AIRE.CAN',
}

export const CancellationDeathAuthorizations = [CancellationsAuthorizations.CancellationDeathIns];
export const CancellationAireAuthorizations = [CancellationsAuthorizations.CancellationAire];

export const CancellationsAuthorizationsList = [
  ...CancellationDeathAuthorizations,
  ...CancellationAireAuthorizations,
];
